import { useCallback, useMemo } from "react";
import { Anchor, Badge, Table, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import type { PendingWorkRow } from "../../types/pendingWork";

interface Props {
  row: PendingWorkRow;
  column: string;
  overdueThresholdDays: number;
}
export function PendingWorkCell({ row, column, overdueThresholdDays }: Props) {
  const handleCaseClick = useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);
  const value = useMemo(
    () =>
      ((
        {
          caseNumber: row.caseNumber,
          patient: row.patient,
          tat: row.tatDays === 0 ? "Today" : `${row.tatDays} days`,
          priority:
            row.priority === 2
              ? "STAT"
              : row.priority === 1
              ? "HIGH"
              : "Normal",
          step: row.currentStatus,
          pendingTests: row.slideCount,
          sendouts: row.sendoutCount,
          otherWork: row.otherCount,
          dateReceived: row.dateReceived,
        } as Record<string, string | number>
      )[column]),
    [column, row]
  );
  return (
    <Table.Td>
      {column === "caseNumber" ? (
        <Anchor
          component={Link}
          to={`/cases/${row.id}`}
          size="sm"
          fw={600}
          onClick={handleCaseClick}
        >
          {value}
        </Anchor>
      ) : column === "priority" && row.priority > 0 ? (
        <Badge color={row.priority === 2 ? "red" : "orange"}>{value}</Badge>
      ) : (
        <Text
          size="sm"
          fw={column === "caseNumber" ? 600 : undefined}
          c={
            column === "tat" && row.tatDays > overdueThresholdDays
              ? "red"
              : undefined
          }
        >
          {value}
        </Text>
      )}
    </Table.Td>
  );
}
